declare global {
  interface Window {
    Shopify?: {
      shop?: string;
      shop_name?: string;
      cdnHost?: string;
      analytics?: {
        publish: (eventName: string, payload: Record<string, unknown>) => void;
      };
    };
    meta?: {
      product?: { id?: number };
      page?: { customerId?: number };
    };
  }
}

export function getShopifyShopId(): string | null {
  if (typeof window === "undefined") return null;
  const shopId = window.Shopify?.shop;
  if (shopId) return shopId;
  if (import.meta.env.DEV) return "rosenectar.myshopify.com";
  return null;
}

export function getShopifyProductId(): number | null {
  if (typeof window === "undefined") return null;
  const productId = window.meta?.product?.id;
  if (productId) return productId;
  if (import.meta.env.DEV) return 3985510694991;
  return null;
}
